import JSection from './JSection';

export default JSection;
